/**
 * Keeps the Android status and navigation bars in step with the app's theme.
 *
 * The shell draws edge to edge, so the system bars contribute nothing but their
 * icons — and Android tints those from the *device's* light/dark setting, which
 * the in-app theme picker is free to disagree with. A phone in dark mode
 * showing the light `classic` theme therefore drew white icons onto the white
 * topbar and the status bar looked empty.
 *
 * `MainActivity` binds a bridge on `window` for the life of the webview; see
 * `src-tauri/mobile/android/MainActivity.kt`. Everywhere else — the browser,
 * the desktop shell, iOS — the object is absent and this is a no-op.
 */
interface SystemBarsBridge {
  setAppearance(light: boolean): void;
}

declare global {
  interface Window {
    AndroidSystemBars?: SystemBarsBridge;
  }
}

/** @param light Whether the active theme paints on a light canvas. */
export function syncSystemBars(light: boolean): void {
  try {
    window.AndroidSystemBars?.setAppearance(light);
  } catch (error) {
    // Cosmetic, and unreachable off Android — never worth failing a theme swap.
    console.warn('Could not restyle the system bars', error);
  }
}
